import { DashboardResponse } from '../../types/dashboard';
import { RegistrationPanel } from './panels/RegistrationPanel';
import { CheckInPanel } from './panels/CheckInPanel';
import { EventsPanel } from './panels/EventsPanel';
import { GuestServicesPanel } from './panels/GuestServicesPanel';
import { LegacyBallPanel } from './panels/LegacyBallPanel';
import { ReunionWeekendPanel } from './panels/ReunionWeekendPanel';

interface AreaContentPanelProps {
  area: string;
  data: DashboardResponse | null;
}

/**
 * Routes to the correct area-specific panel based on the area parameter.
 */
export function AreaContentPanel({ area, data }: AreaContentPanelProps) {
  if (!data) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          color: '#ffffff',
          fontSize: '32px',
          fontFamily: "'Inter', system-ui, sans-serif",
          background: '#0d1b12',
        }}
      >
        Loading...
      </div>
    );
  }

  switch (area) {
    case 'registration':
      return <RegistrationPanel data={data} />;
    case 'check-in':
      return <CheckInPanel data={data} />;
    case 'events':
      return <EventsPanel data={data} />;
    case 'guest-services':
      return <GuestServicesPanel data={data} />;
    case 'legacy-ball':
      return <LegacyBallPanel data={data} />;
    case 'reunion-weekend':
      return <ReunionWeekendPanel data={data} />;
    default:
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            color: '#ffffff',
            fontSize: '32px',
            fontFamily: "'Inter', system-ui, sans-serif",
            background: '#0d1b12',
          }}
        >
          Unknown dashboard area
        </div>
      );
  }
}
